import * as turf from '@turf/turf';
import booleanIntersects from '@turf/boolean-intersects';

import {ItemsTile} from './ItemsTile';

export class ItemsTileHelper {

  public static calculateFigureTiles(figure) {
    const figureBbox = turf.bbox(figure);
    //console.log('[ITEMS CANVAS] figure', figure);
    //console.log('[ITEMS CANVAS] figureBbox', figureBbox);

    const tilesXYs = new Map();

    this.calculateLngLatBoxTiles(figureBbox).forEach((tileXY) => {
      const rectangle = ItemsTile.calculateRectangle(tileXY.x, tileXY.y);

      const leftTopLatLng =  Cesium.Rectangle.northwest(rectangle);
      const rightBottomLatLng = Cesium.Rectangle.southeast(rectangle);

      const bbox: turf.BBox = [
        Cesium.Math.toDegrees(leftTopLatLng.longitude), Cesium.Math.toDegrees(rightBottomLatLng.latitude),
        Cesium.Math.toDegrees(rightBottomLatLng.longitude), Cesium.Math.toDegrees(leftTopLatLng.latitude)
      ];

      const poly = turf.bboxPolygon(bbox);
      if (booleanIntersects(figure, poly)) {
        const tileXYWithNeighboring = ItemsTileHelper.getTileWithNeighboring(tileXY);
        tileXYWithNeighboring.forEach((xy) => {
          tilesXYs.set(ItemsTile.generateKey(xy.x, xy.y), xy);
        });
      }
    });

    // console.log('[ITEMS CANVAS] tilesXYs', tilesXYs);
    return tilesXYs;
  }

  public static getTileWithNeighboring(tileXY) {
    const tilesXYs = [];
    for (let x = tileXY.x - 1; x <= tileXY.x + 1; x++) {
      for (let y = tileXY.y - 1; y <= tileXY.y + 1; y++) {
        const xy = {x, y};
        tilesXYs.push(xy);
      }
    }
    return tilesXYs;
  }


  public static calculateLngLatBoxTiles(bbox) {
    const p1XY = ItemsTile.xyFromDegrees(bbox[1], bbox[0]);
    const p2XY = ItemsTile.xyFromDegrees(bbox[3], bbox[2]);

    const minXY = { x: Math.min(p1XY.x, p2XY.x), y: Math.min(p1XY.y, p2XY.y) };
    const maxXY = { x: Math.max(p1XY.x, p2XY.x), y: Math.max(p1XY.y, p2XY.y) };

    const tilesXYs = [];
    for (let x = minXY.x; x <= maxXY.x; x++) {
      for (let y = minXY.y; y <= maxXY.y; y++) {
        tilesXYs.push({x, y});
      }
    }

    // console.log('[ITEMS CANVAS] tilesXYs', tilesXYs);
    return tilesXYs;
  }

}
